import { action } from 'satcheljs';
import type { ClientItemId } from 'owa-client-ids';

/**
 * Dispatched after a user save of a full compose form launched with a `saveCorrelationId`,
 * so the launcher can react to the saved event.
 */
export interface CalendarComposeEventSavedActionMessage {
    saveCorrelationId: string;
    itemId: ClientItemId;
    subject: string | undefined;
}
export const calendarComposeEventSaved: (
    saveCorrelationId: string,
    itemId: ClientItemId,
    subject: string | undefined
) => CalendarComposeEventSavedActionMessage = action(
    'calendarComposeEventSaved',
    (
        saveCorrelationId: string,
        itemId: ClientItemId,
        subject: string | undefined
    ): CalendarComposeEventSavedActionMessage => ({
        saveCorrelationId,
        itemId,
        subject,
    })
);
